function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useContext } from "react";
import { DEFAULT_ICON_FETCH, IconContext, formatPath as baseFormatPath } from "../IconProvider/index";
import { useIconAttributes } from "../../hooks/useSvgAttributes";
export var Icon = forwardRef(function(_param, ref) {
    var pack = _param.pack, path = _param.path, name = _param.name, href = _param.href, _param_size = _param.size, size = _param_size === void 0 ? "xs" : _param_size, _param_role = _param.role, role = _param_role === void 0 ? "img" : _param_role, rest = _object_without_properties(_param, [
        "pack",
        "path",
        "name",
        "href",
        "size",
        "role"
    ]);
    var _useContext;
    var _ref = (_useContext = useContext(IconContext)) !== null && _useContext !== void 0 ? _useContext : {
        formatPath: baseFormatPath,
        useFetch: DEFAULT_ICON_FETCH
    }, formatPath = _ref.formatPath, useFetch = _ref.useFetch;
    var _useIconAttributes = useIconAttributes(_object_spread_props(_object_spread({}, rest), {
        size: size,
        role: role
    })), title = _useIconAttributes.title, desc = _useIconAttributes.desc, attributes = _useIconAttributes.attributes;
    var data = useFetch(formatPath({
        path: path,
        pack: pack,
        name: name
    }));
    return _jsxs("svg", _object_spread_props(_object_spread({}, attributes), {
        ref: ref,
        children: [
            title,
            desc,
            data
        ]
    }));
});
export default Icon;
